import _, { find } from "lodash";
import { Fragment, memo, useCallback, useMemo } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import SelectComponent from "../../_Components/ReactSelectComponent"
import AddCircleRounded from "@mui/icons-material/AddCircleOutlineRounded";
import ReserveItemGroup from "./ReserveItemGroup";


const CreateReserveFormDate = ({
  formatTime,
  service,
  reserveDetail,
  reserveDescriptions,
  reserveItemGroups,
  reserveItems,
  date,
  setModalNameDate,
  setShowModalAddDescription,
}) => {
  const { control, ...methods } = useFormContext()
  const nameDate = useMemo(() => reserveDetail.isDefault ? "default" : date?.nameDate, [date, reserveDetail])
  const reserveDetailJson = useMemo(() => reserveDetail?.json, [reserveDetail.json])
  const openModalAddDescription = useCallback((nameDate, groupId) => {
    var formattedNameDate = "";
    if (groupId != 0) {
      formattedNameDate = `${nameDate}-${service}-${groupId}-Des`;
    } else {
      formattedNameDate = `${nameDate}-${service}-Des`;
    }
    setModalNameDate(formattedNameDate);
    setShowModalAddDescription(true);
  }, [setModalNameDate, setShowModalAddDescription]);

  const isDefaultSetter = (template, patternDatee) => {
    const convertedObj = {}
    convertedObj[`${patternDatee}-${service}-IA`] = template.dIA
    convertedObj[`${patternDatee}-${service}-Des`] = find(reserveDescriptions, (function (obj) {
      return _.toString(obj.value) == template.dDesId;
    }) ?? null)

    reserveItemGroups.forEach(group => {
      const groupValue = template?.g?.find(gg => gg.gId == group.id)
      convertedObj[`${patternDatee}-${service}-${group.id}-ID`] = groupValue?.gID
      convertedObj[`${patternDatee}-${service}-${group.id}-IA`] = groupValue?.gIA
      convertedObj[`${patternDatee}-${service}-${group.id}-Des`] = find(reserveDescriptions, (function (obj) {
        return _.toString(obj.value) == groupValue?.gDesId;
      }) ?? null)
      reserveItems?.forEach(ii => {
        const itemValue = groupValue?.i.find(rt => rt.iId == ii.id)
        convertedObj[`${patternDatee}-${service}-${group.id}-${ii.id}-ID`] = itemValue?.iID
        convertedObj[`${patternDatee}-${service}-${group.id}-${ii.id}-IA`] = itemValue?.iIA
        convertedObj[`${patternDatee}-${service}-${group.id}-${ii.id}-C`] = itemValue?.iC ?? ii?.defaultReserveCountPerDay
        convertedObj[`${patternDatee}-${service}-${group.id}-${ii.id}-MinC`] = itemValue?.iMinC ?? ii?.minimumReserveCountPerDay
        convertedObj[`${patternDatee}-${service}-${group.id}-${ii.id}-MGC`] = itemValue?.iMGC
        convertedObj[`${patternDatee}-${service}-${group.id}-${ii.id}-IFC`] = itemValue?.iIFC ?? ii?.iIFC
      })
    })
    const oldValues = Object.fromEntries(
      Object.entries(methods.getValues()).filter(([key]) => !key.includes("-"))
    )
    methods.reset({
      ...oldValues,
      ...convertedObj
    })
  }

  return (
    <>
      {
        !_.isUndefined(reserveItemGroups) &&
        !_.isEmpty(reserveItemGroups) &&
        reserveItemGroups.length > 0 &&
        !_.isUndefined(reserveItems) &&
        !_.isEmpty(reserveItems) &&
        <Col key={nameDate} xs="12" className="mt-2 p-0">
          <Col className="rounded-3" style={{ border: "1px solid #a2a6b9", backgroundColor: "#eef0f8" }}>
            <Row className="justify-content-md-right py-3 " style={{ backgroundColor: "#c6cad7" }}>
              <Col xs="12" sm="7" className="pt-2 position-relative">
                <Controller
                  control={control}
                  key={JSON.stringify(reserveDetailJson)}
                  name={`${nameDate}-${service}-IA`}
                  render={({ field }) => <input
                    type="checkbox"
                    style={{ margin: "0 5px" }}
                    title="فعال/غیرفعال"
                    checked={field.value ?? false}
                    {...field}
                  />}
                />
                {reserveDetail.isDefault ? "تاریخ های پیش فرض" : date.formattedDate + " " + date.persianDayOfWeek}
              </Col>
              <Col xs="10" sm="5" className="mt-2 mt-md-0 pr-2 d-flex align-items-center">
                <Controller
                  name={`${nameDate}-${service}-Des`}
                  control={control}
                  key={JSON.stringify(reserveDetailJson)}
                  render={({ field }) => (
                    <SelectComponent
                      className="w-100"
                      variant="outlined"
                      size="small"
                      placeholder="توضیحات تاریخ"
                      options={reserveDescriptions.map(item => ({ ...item, label: item.label.length > 40 ? item.label.slice(0, 40) + "…" : item.label }))}
                      onChange={field.onChange}
                      value={field.value}
                    />
                  )}
                />
                <Button
                  onClick={() => openModalAddDescription(nameDate, 0)}
                  variant="light h-100 mx-1"
                >
                  <AddCircleRounded
                    fontSize="large"
                    className="big-icon"
                  />
                </Button>

              </Col>
            </Row>
            <div >
              {reserveItemGroups.map(function (group, index) {
                let reserveDetailGroup =
                  reserveDetailJson && _.isArray(reserveDetailJson.g)
                    ? _.find(reserveDetailJson.g, { gId: group.id })
                    : "";

                return (
                  <Fragment key={index}>
                    {!_.isUndefined(group) && !_.isEmpty(group) &&
                      <ReserveItemGroup
                        nameDate={nameDate}
                        group={group}
                        service={service}
                        reserveDescriptions={reserveDescriptions}
                        reserveDetailGroup={reserveDetailGroup}
                        reserveDetailJson={reserveDetailJson}
                        isDefaultSetter={isDefaultSetter}
                        openModalAddDescription={openModalAddDescription}
                        reserveItems={reserveItems}
                        formatTime={formatTime}
                      />
                    }
                  </Fragment>
                )
              })}
            </div>
          </Col>
        </Col>
      }
    </>

  );
};

export default memo(CreateReserveFormDate)